export default "__VITE_ASSET__uQZXMSzm__"